import NewsletterForm from './NewsletterForm';

export default NewsletterForm;
